import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import Swal from 'sweetalert2';
import { CellTemplateDirective, DataTable, PageHeader, SectionHeader, TableActions, actionPreset } from '@intelishs-group/ui';
import type { ActionButtonDef, ColumnDef } from '@intelishs-group/ui';

interface DemoRow {
  id: number;
  nombre: string;
  fecha: string;
  estatus: string;
  bactivo: boolean;
}

@Component({
  selector: 'app-dashboard',
  imports: [CellTemplateDirective, DataTable, PageHeader, SectionHeader, TableActions],
  templateUrl: './dashboard.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPage {
  // Datos de ejemplo: sustituir por datos del servicio del dominio
  data = signal<DemoRow[]>([
    { id: 1, nombre: 'Registro de ejemplo', fecha: '2026-01-15', estatus: 'Activo', bactivo: true },
    { id: 2, nombre: 'Otro registro', fecha: '2026-02-20', estatus: 'Pendiente', bactivo: true },
    { id: 3, nombre: 'Registro inactivo', fecha: '2026-03-05', estatus: 'Inactivo', bactivo: false },
  ]);
  loading = signal(false);

  columns: ColumnDef<DemoRow>[] = [
    { key: 'id', header: 'ID', width: '60px', align: 'center', sortable: true },
    { key: 'nombre', header: 'Nombre', width: 'auto', filterable: true, sortable: true },
    { key: 'fecha', header: 'Fecha', type: 'date', align: 'center', width: '110px', sortable: true },
    {
      key: 'estatus',
      header: 'Estatus',
      type: 'tag',
      align: 'center',
      width: '115px',
      filterable: true,
      tagColorFn: (value) =>
        value === 'Activo' ? '#52c41a' : value === 'Pendiente' ? '#faad14' : '#8c8c8c',
    },
    { key: 'bactivo', header: 'Activo', type: 'boolean', align: 'center', width: '90px' },
    { key: 'acciones', header: 'Acciones', type: 'custom', align: 'center', width: '120px' },
  ];

  actions: ActionButtonDef<DemoRow>[] = [
    actionPreset('ver'),
    actionPreset('editar'),
    actionPreset('borrar', { visible: (row) => row.bactivo }),
  ];

  onAction(action: string, row: DemoRow): void {
    Swal.fire({ title: action, text: `Fila: ${row.nombre}`, icon: 'info' });
  }

  onAdd(): void {
    Swal.fire({ title: 'Agregar', text: 'Aqui se abre el modal de alta', icon: 'info' });
  }
}
